import KitModal from '@omni/kit/components/KitModalV2';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import ActionItem from '../ActionItem';

interface IProps {
  isVisible: boolean;
  onClose: () => void;
  onDeleteMessage: () => void;
}

export default ({
  isVisible,
  onClose,
  onDeleteMessage,
}: IProps): ReactElement => {
  const insets = useSafeAreaInsets();

  const { t } = useTranslation(['liveChat']);

  const onPress = () => {
    onDeleteMessage();
  };

  return (
    <KitModal anchorBottom={true} isVisible={isVisible} onClose={onClose}>
      <View style={[styles.container, { paddingBottom: insets.bottom }]}>
        <ActionItem
          iconName='delete'
          iconSize={22}
          label={t('liveChat:deleteMessageActionName')}
          onPress={onPress}
        />
      </View>
    </KitModal>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.m,
    paddingBottom: Spacing.xl,
    paddingHorizontal: Spacing.l,
    width: '100%',
  },
});
